import ConfigSeoApi from "../configs/ConfigSeoApi";
import Cookies from "js-cookie";

// "SEO by URLs" — the `bs_seo` templates the old admin edited. The table still
// lives in the monolith's MySQL, but the seo service owns it: it is the one
// that serves these texts to the front, so the CMS talks to it directly, the
// way it does for custom pages.
const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getList = (lang, { q = "", page = 1, perPage = 20 } = {}) =>
  ConfigSeoApi.get(`/api/admin/manual-seo/${lang}`, {
    params: { q, page, per_page: perPage },
    headers: headers(),
  });

// the public read, the same one the front uses: it answers `[]` for a template
// with nothing written in this language
const getOne = (lang, url) => ConfigSeoApi.get(`/api/manual-seo/${lang}`, { params: { url } });

// upsert: the service creates the `bs_seo` row when the URL template is new
const save = (lang, url, fields) =>
  ConfigSeoApi.patch(`/api/admin/manual-seo/${lang}`, fields, {
    params: { url },
    headers: headers(),
  });

// drops the texts of this language only; the URL template goes when the last
// language does
const remove = (lang, url) =>
  ConfigSeoApi.delete(`/api/admin/manual-seo/${lang}`, { params: { url }, headers: headers() });

export default {
  getList,
  getOne,
  save,
  remove,
};
